export const SUBMENU = {
  DEFAULT: 0,
  ENERGY_RESOURCES: 1,
  ASSETS: 2,
  MANAGEMENT_CENTRE: 3,
  FINANCE: 4,
  OPERATIONS: 5,
};
